import AccessGroupsList from './AccessGroupsList';

export default AccessGroupsList;
